export default {
	add_to_calendar: "Add to Calendar",
	available_on_level: "Available on level",
	begin_date: "Start Date",
	check_in: "Check-in",
	checked_in: "Checked-in",
	code: "Code",
	doesnt_have_a_qrcode_reader_enter_the_check_in_code_bellow: "Don´t have a QR code reader? Enter the check-in code below.",
	dont_forget_to_come_and_visit_us_at: "Welcome to Intel Friends events!",
	end_date: "End Date",
	enter_the_check_in_code_bellow: "Enter the check-in code below.",
	enter_your_six_digits_code: "Please enter your six-digit code",
	event_type: "Event Type",
	get_back_later_to_check_new_event_available_to_you: "Get back later to check new events available to you.",
	join_exclusive_events_for_intel_rewards_you_users_and_power_up_your_connection_with_the_intel_network: "Join exclusive events for Intel Rewards You users and power up your connection with the Intel network!",
	no_events_are_available_at_the_moment: "No events are available at the moment.",
	read_the_qrcode_at_the_event_to_check_in: "Please, read the QR code at the event to check-in.",
	read_the_qrcode_available_at_the_event_to_check_in: "Read the QR Code available at the event to mark your presence.",
	signed_up: "Signed up",
	signup: "Sign up",
	thank_you_for_participating_in_our_event_see_you_on_the_next_one: "Thank you for participating in our event. See you in the next one!",
	the_code_sent_is_invalid_confirm_the_code_with_the_event_organization: "This code is invalid. Please, confirm the code with the event's organization."
}